import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  ApiPostSystemMessage,
  ApiGetSystemMessage,
  ApiPutSystemMessage,
  ApiDeleteSystemMessage
} from './taxMatrix.api';

export const postSystemMessage = createAsyncThunk(
  'api/createsystemmessage',
  async (data) => {
    let response = await ApiPostSystemMessage(data);
    return response;
  }
);

export const getSystemMessage = createAsyncThunk(
  'api/getsystemmessage',
  async () => {
    let response = await ApiGetSystemMessage();
    return response;
  }
);

export const putSystemMessage = createAsyncThunk(
  'api/updatesystemmessage',
  async (data) => {
    console.log('datadata', data);
    let response = await ApiPutSystemMessage(data);
    return response;
  }
);

export const deleteSystemMessage = createAsyncThunk(
  'api/deletesystemmessage',
  async (id) => {
    let response = await ApiDeleteSystemMessage(id);
    return response;
  }
);
export const taxMatrixDataSlice = createSlice({
  name: 'TaxMatrix',
  initialState: {
    //post system message
    isLoadingPostSystemMessage: false,
    postedSystemMessage: {},
    //get system message
    listSystemMessage: {},
    isLoadinglistSystemMessage: false,
    //put system message
    putSystemMessage: {},
    isLoadingPutSystemMessage: false,
    //delete system message
    isDeletingSystemMessage: false
  },
  reducers: {},
  extraReducers: {
    //----------post system message----------//
    [postSystemMessage.pending]: (state) => {
      state.isLoadingPostSystemMessage = 'loading';
    },
    [postSystemMessage.fulfilled]: (state, action) => {
      state.isLoadingPostSystemMessage = 'success';
      state.postedSystemMessage = action.payload;
    },
    [postSystemMessage.rejected]: (state) => {
      state.isLoadingPostSystemMessage = 'failed';
    },
    //----------get system message----------//
    [getSystemMessage.pending]: (state) => {
      state.isLoadinglistSystemMessage = 'loading';
    },
    [getSystemMessage.fulfilled]: (state, action) => {
      state.isLoadinglistSystemMessage = 'success';
      state.listSystemMessage = action.payload;
    },
    [getSystemMessage.rejected]: (state) => {
      state.isLoadinglistSystemMessage = 'failed';
    },
    //----------put system message----------//
    [putSystemMessage.pending]: (state) => {
      state.isLoadingPutSystemMessage = 'loading';
    },
    [putSystemMessage.fulfilled]: (state, action) => {
      state.isLoadingPutSystemMessage = 'success';
      state.putSystemMessage = action.payload;
    },
    [putSystemMessage.rejected]: (state) => {
      state.isLoadingPutSystemMessage = 'failed';
    },
    //----------delete system message----------//
    [deleteSystemMessage.pending]: (state) => {
      state.isDeletingSystemMessage = 'loading';
    },
    [deleteSystemMessage.fulfilled]: (state) => {
      state.isDeletingSystemMessage = 'success';
    },
    [deleteSystemMessage.rejected]: (state) => {
      state.isDeletingSystemMessage = 'failed';
    }
  }
});

export const taxMatrixSelector = (state) => state.taxMatrixData;

export default taxMatrixDataSlice.reducer;
